import { FC } from 'react';
import classlist from 'utils/classlist';
import styles from './style.scss';

interface TagProps {
    className?: string;
    text: string;
    onClick?: () => void;
    variant?: 'success' | 'info' | 'warning' | 'error' | 'default';
    size?: 'sm' | 'lg';
}

// 设计稿：https://www.figma.com/design/7lfUKmAiXbsm5y0oC82NQN/Web-H5%E8%A7%84%E8%8C%83?node-id=285-2036
const Tag: FC<TagProps> = ({ className, text, onClick, variant = 'default', size = 'sm' }) => {
    return (
        <span
            className={classlist(styles.root, className, {
                [styles.success]: variant === 'success',
                [styles.info]: variant === 'info',
                [styles.warning]: variant === 'warning',
                [styles.error]: variant === 'error',
                [styles.default]: variant === 'default',
                [styles.clickable]: !!onClick,
                [styles.large]: size === 'lg'
            })}
            onClick={onClick}>
            {text}
        </span>
    );
};

export default Tag;
